import {IApiModel} from './api-model.interface';

export class SignIn implements IApiModel<SignIn> {
    email: string;
    password: string;
    rememberMe: boolean;
    recaptcha_response?: string;

    public constructor(init?: Partial<SignIn>) {
        Object.assign(this, init);
    }

    getApiModel(): any {
        return {
            username: this.email.toLowerCase(),
            password: this.password,
            recaptcha_response: this.recaptcha_response
        }
    }

    setFromApiModel(apiModel: any): this {
        throw new Error('Method not implemented.');
    }
}
